let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files

  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/product-form.js?v=120457291108000046811762866285");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/shopflo.bundle.js?309658");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/pubsub.js?v=158010494145168011771762867843");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/cart-notification.js?v=133508293167896966491762866282");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/constants.js?v=132983761750457495441762866284");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/cart.js?v=95316439595850377071762866283");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/cart-drawer.js?v=128316375710618273351762866286");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-scroll-tab.js?v=110537738839353943101762866285");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/collapsable-combo-section.js?v=23924472764557253391762866284");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-available-offers.js?309658");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-details.js?v=133041400373156940781762866283");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-recom-prods.js?309658");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/edd-section.js?v=100119633110064442781762866285");
  

  
  
    

  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/collapsible-content.css?v=40054841430043683651762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-accordion.css?v=181330424127687678861762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-social-reviews.css?v=74717896916299017681762866286");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-available-offers.css?v=112077318425957018091762866282"); 
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-scroll-tab.css?v=132899465197510878951762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/new_serums_section.css?v=93889447425504097401762866286");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/sunscreen-quiz-pdp.css?v=150892412449710366031762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/new-details-collapsable.css?v=21783054330784661661762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-color-swatch.css?v=141246657724163601551763015414");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/all.min.css?v=36347114306294163891762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-price.css?v=70172745017360139101762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-card.css?v=158102377163184793191762866286");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart.css?v=49529066954642232561762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-mega-menu.css?v=122458266873942644791762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-totals.css?v=45024014013762792871762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart-drawer.css?v=71577824717805454931762877476");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-discounts.css?v=152760482443307489271762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/searchtap.css?v=111603181540343972631762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-list-menu.css?v=151968516119678728991762866286");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-search.css?v=165164710990765432851762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-menu-drawer.css?v=20646116693146970981762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart-notification.css?v=54116361853792938221762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart-items.css?v=47901327362710772261762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-collection-hero.css?v=150137544140055157131762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/quick-add.css?v=66647833350618835731762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-show-more.css?v=139536189637226996221762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-swatch-input.css?v=61683592951238328641762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-swatch.css?v=68619770617697936771762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/collapsable-combo-section.css?v=16640933633868879741762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-feature-svg.css?v=107811230276467158871762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-recom-prods.css?v=79113754582887175411762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/edd-section.css?v=151752159037241140411762866285");


   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/details-modal.js?v=119528565511025453401762866283");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/details-disclosure.js?v=13653116266235556501762866282");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
